"use client";

import { cn } from "@/components/common/utils";
import React from "react";

export const HorizontalLoadingBar = ({ count }: { count: number }) => {
  if (count === 0) return null;

  return (
    <>
      <div
        className={cn(
          "bg-primary h-2 md:h-3 bottom-0 absolute animate-linear-loader w-full z-50",
          count === 1 ? "duration-7700" : "duration-7950"
        )}
      ></div>
    </>
  );
};

export default HorizontalLoadingBar;
